import { customerTable } from "./defaultTableColumns";

export const defaultTablePerPageCount = 50;

const baseTablePreferenceData = {
  pageNo: 1,
  sortColumn: "created_at",
  sortDirection: "desc",
  perPageCount: defaultTablePerPageCount,
  filters: [],
};

export const defaultTablePreferenceData = {
  ticket: {
    ...baseTablePreferenceData,
  },
  customer: {
    columns: customerTable,
    ...baseTablePreferenceData,
  },
};
